import { QuestionTypes, QuestionUniqueNames, Sections } from '../../../../core/enums';
import { businessTheme, estateTheme, personalTheme, wealthTheme } from '../../../themes/brandingTheme';

export interface Question {
	uniqueName: QuestionUniqueNames;
	type: QuestionTypes;
	title: string;
	section: QuestionSection;
	subTitle?: string;
	sliderTitle?: string;
	options: QuestionOption<string | number>[];
	bonusScore?: BonusScore;
	helpSection?: HelpSection;
	saveAnswerToLocal?: boolean; // Must have uniqueName
	visible?: VisibleCondition[]; // Only support 'or' operation for now.
	sourceColumnTitle?: string; // Required for DragAndDropQuestion
	destinationColumnTitle?: string; // Required for DragAndDropQuestion
}

export interface QuestionOption<T> {
	value: T;
	label: string;
	score?: number;
	override?: boolean; // When select this option, will override all other selected options, eg: 'None of above' option.
	showOtherTextField?: boolean; // For 'Other (specify)' field to show an extra text field.
	visible?: VisibleCondition[]; // Only support 'or' operation for now.
}

export interface BonusScore {
	score: number;
	atLeastSelected: number; // Condition to get bonus score.
}

export interface VisibleCondition {
	questionUniqueName: QuestionUniqueNames;
	matchedValues: string[];
}

export interface HelpSection {
	title: string;
	content?: string[];
}

export interface QuestionSection {
	title: string;
	introduction: string;
}

export const getQuestionSectionColour = (section: string) => {
	switch (section) {
		case Sections.Personal:
			return personalTheme.brandingColourHeavy;
		case Sections.Business:
			return businessTheme.brandingColourHeavy;
		case Sections.Wealth:
			return wealthTheme.brandingColourHeavy;
		case Sections.Estate:
			return estateTheme.brandingColourHeavy;
		default:
			throw new Error(`Unknown question section: ${section}`);
	}
};
